import React from 'react';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { Component } from '../../../../dispatcher/modules';
import PuzzleButton from '../button/../PuzzleButton';
import { Position } from '../../../../dispatcher/Types';
import * as _ from 'lodash';
import { BADGE_BUTTON_PROPS, BADGE_BUTTON_STATE } from './Types';

/**
 * @class BadgeButton
 * A button with a badge indicator
 */
class BadgeButton extends Component<BADGE_BUTTON_PROPS, BADGE_BUTTON_STATE> {
  state: {
    indicator: 0,
    handleClick: null,
    action: null
  }

  constructor(props: any) {
    super(props);

    if (_.isFunction(props.handleClick) && props.action) {
      throw new Error('Configuration conflict! Please provide `handleClick` method or `action` that will be triggered via Dispatcher!');
    }

    this.state = {
      ...this.state,
      ...props
    };
  }

  /**
   * @private
   * Button click handler.
   * This handler will user action string from props and trigger dispatcher action
   */
  private handleClick = () => {
    if (this.props.action) {
      this.dispatch(this.props.action, Position.end);
    }
  }

  /**
   * @public
   * Updates badge indicator in the state object
   * @param {number} indicator
   */
  public updateBadge = (indicator = 0) => {
    this.setState({
      indicator
    });
  }

  /**
   * @override
   */
  renderBody() {
    let { handleClick = this.handleClick } = this.state;
    handleClick = handleClick ? handleClick : this.handleClick;
    const badgeProps = _.omit(this.props, ['indicator', 'action', 'handleClick']);
    const {
      text,
      titleText,
      withTooltip,
      tooltipContent,
      tooltipPosition,
      tooltipAnchor,
      tooltipOpenDelay,
      tooltipClassName,
      buttonClass,
      iconClass,
      ariaLabel
    } = this.props;

    return (
      <BadgeContainer>
        <PuzzleButton
          aria-label={ariaLabel}
          titleText={titleText}
          withTooltip={withTooltip}
          className={buttonClass}
          iconClass={`tp-icon tp-${iconClass}`}
          onClick={handleClick}
          tooltipContent={tooltipContent}
          tooltipPosition={tooltipPosition}
          tooltipAnchor={tooltipAnchor}
          tooltipOpenDelay={tooltipOpenDelay}
          tooltipClassName={tooltipClassName}
        >
          {text}
        </PuzzleButton>
        <Badge rounded={'full'}{...badgeProps}>
          {this.state.indicator}
        </Badge>
      </BadgeContainer>
    );
  }
}

export default BadgeButton;
